module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/haircut-desktop@3x-7a2f4d0081a35b0369b2dc32c82e8561.jpg";